const baseURL = 'https://apertai.uc.r.appspot.com';

// Busca os horários disponíveis para um dia específico
export const getVideoHours = async ({ queryKey }: any) => {
  const [, state, city, arena, date, subcourt] = queryKey;
  const response = await fetch(
    `${baseURL}/videos/hours?state=${state}&city=${city}&name=${arena}&date=${date}&subcourt=${subcourt.replace(/\s/g, '')}`
  );

  return await response.json();
};

// Busca os vídeos de uma faixa horária específica
export const getVideosByHour = async ({ queryKey }: any) => {
  const [, state, city, arena, date, subcourt, hour] = queryKey;
  const response = await fetch(
    `${baseURL}/videos/byhour?state=${state}&city=${city}&name=${arena}&date=${date}&subcourt=${subcourt.replace(/\s/g, '')}&hour=${hour}`
  );

  return await response.json();
};

export const getArena = async ({ queryKey }: any) => {
  const [, city] = queryKey;
  const response = await fetch(`${baseURL}/arena?city=${city}`);

  return await response.json();
};

// Envia um lead de patrocínio (marca quer aparecer nos vídeos da arena)
export const postSponsorLead = async (payload: {
  full_name: string;
  phone: string;
  arena_name?: string;
  message?: string;
}) => {
  const response = await fetch(`${baseURL}/leads`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...payload, type: 'sponsor' }),
  });
  if (!response.ok) throw new Error('Falha ao enviar o lead');
  return await response.json();
};

// Dados da página de patrocínio de uma arena (estatísticas + vídeo de exemplo)
export const getSponsor = async ({ queryKey }: any) => {
  const [, arenaSlug, pass] = queryKey;
  const url = `${baseURL}/sponsor?arena=${encodeURIComponent(arenaSlug)}` +
    (pass ? `&pass=${encodeURIComponent(pass)}` : '');
  const response = await fetch(url);
  if (!response.ok) throw new Error('Arena não encontrada');
  return await response.json();
};
